import React from "react";
import CategoryPage from "./CategoryPage";

function Environment({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Environment"
      parentCategory="Articles"
      posts={posts}
      publications={publications}
    />
  );

}

export default Environment;